import { useEffect, useMemo } from 'react';
export const flattenData = (data, labelAccessor) => {
  return data.reduce((flat, d) => {
    const label = labelAccessor(d);
    if (flat[label]) {
      return flat;
    }
    const newFlatData = {
      ...flat
    };
    newFlatData[label] = d;
    return newFlatData;
  }, {});
};
export const parseValue = value => {
  if (value === 'normal') {
    return 8;
  } else {
    return parseFloat(value);
  }
};
export function useTruncationIndexObserver(_ref) {
  let {
    legendRefCurrent,
    setTruncationIndex
  } = _ref;
  useEffect(() => {
    const observer = new ResizeObserver(entries => {
      let fit = 0;
      const content = [...entries[0].target.children];
      content.forEach(d => {
        // Look into isVisible function
        if (!isItIn(entries[0].target, d)) {
          fit += 1;
        }
      });
      setTruncationIndex(fit);
    });
    if (legendRefCurrent) {
      observer.observe(legendRefCurrent);
    }
    return () => {
      if (legendRefCurrent) {
        observer.unobserve(legendRefCurrent);
      }
    };
  }, [legendRefCurrent, setTruncationIndex]);
}
export const isItIn = (parent, child) => {
  const box1coords = parent.getBoundingClientRect();
  const box2coords = child.getBoundingClientRect();
  if (box2coords.top + 2 < box1coords.top || box2coords.right - 2 > box1coords.right || box2coords.bottom - 2 > box1coords.bottom || box2coords.left + 2 < box1coords.left) {
    return true;
  }
  return false;
};
export function useFlatData(_ref2) {
  let {
    labelAccessor,
    data
  } = _ref2;
  return useMemo(() => Object.values(data.reduce((flat, d) => {
    const label = labelAccessor(d);
    if (flat[label]) {
      return flat;
    }
    const newFlatData = {
      ...flat
    };
    newFlatData[label] = {
      ...d
    };
    return newFlatData;
  }, {})), [labelAccessor, data]);
}